const numberHi: Record<number, { title: string; meaning: string; guidance: string; direction: string }> = {
  1: {
    title: 'करियर और पहल',
    meaning: 'स्वतंत्रता, पहल, संवाद और करियर में आगे बढ़ने की ऊर्जा।',
    guidance: 'नेतृत्व को विनम्रता के साथ रखें और फैसलों को व्यावहारिक बनाएं।',
    direction: 'उत्तर',
  },
  2: {
    title: 'रिश्ते और संवेदनशीलता',
    meaning: 'सहयोग, साझेदारी, अंतर्ज्ञान और भावनात्मक संवेदनशीलता।',
    guidance: 'रिश्तों में धैर्य बढ़ाएं और अधिक निर्भरता से बचें।',
    direction: 'दक्षिण-पश्चिम',
  },
  3: {
    title: 'परिवार और अभिव्यक्ति',
    meaning: 'ज्ञान, परिवार का सहयोग, रचनात्मकता, सीखना और अभिव्यक्ति।',
    guidance: 'विचारों को नियमित सीखने और सकारात्मक संवाद में बदलें।',
    direction: 'पूर्व',
  },
  4: {
    title: 'अनुशासन और धन-प्रयास',
    meaning: 'व्यवस्था, अनुशासन, धन-योजना, सिस्टम और व्यावहारिक मेहनत।',
    guidance: 'शॉर्टकट से बचें; रूटीन और आर्थिक अनुशासन मदद करेगा।',
    direction: 'दक्षिण-पूर्व',
  },
  5: {
    title: 'संतुलन और केंद्र',
    meaning: 'संतुलन, अनुकूलन, रूटीन, संवाद और स्वतंत्रता।',
    guidance: 'लचीलापन बनाए रखते हुए जीवन में संरचना बनाएं।',
    direction: 'केंद्र',
  },
  6: {
    title: 'सहयोगी और सामंजस्य',
    meaning: 'सहयोग, मार्गदर्शक, जिम्मेदारी, सौंदर्य, सुविधा और पारिवारिक सामंजस्य।',
    guidance: 'सुविधा और जिम्मेदारी में संतुलन रखें और अच्छे सहयोगी चुनें।',
    direction: 'उत्तर-पश्चिम',
  },
  7: {
    title: 'रचनात्मकता और आंतरिक खोज',
    meaning: 'शोध, अंतर्ज्ञान, रचनात्मकता, आनंद और गहरी खोज।',
    guidance: 'एकांत को समझ के लिए इस्तेमाल करें, अलगाव के लिए नहीं।',
    direction: 'पश्चिम',
  },
  8: {
    title: 'ज्ञान और महत्वाकांक्षा',
    meaning: 'ज्ञान, महत्वाकांक्षा, संगठन, धैर्य और दीर्घकालिक विकास।',
    guidance: 'धैर्य, योजना और नैतिक मेहनत से प्रगति मजबूत होती है।',
    direction: 'उत्तर-पूर्व',
  },
  9: {
    title: 'यश और पूर्णता',
    meaning: 'प्रतिष्ठा, साहस, आदर्श, दृश्यता और सेवा की भावना।',
    guidance: 'तीव्र ऊर्जा को सेवा, साहस और अनुशासित कार्य में लगाएं।',
    direction: 'दक्षिण',
  },
};

const arrowHi: Record<string, { name: string; strength: string; weakness: string }> = {
  mental: {
    name: 'मानसिक / विचार रेखा',
    strength: 'स्पष्ट सोच, स्मरण शक्ति, योजना और निर्णय क्षमता को समर्थन मिलता है।',
    weakness: 'योजना, सीखने की लय और मानसिक फोकस पर सचेत काम करने की जरूरत हो सकती है।',
  },
  emotional: {
    name: 'भावनात्मक / हृदय रेखा',
    strength: 'भावनात्मक समझ, रचनात्मकता, श्रद्धा और आंतरिक संवेदनशीलता बढ़ती है।',
    weakness: 'भावनात्मक अभिव्यक्ति और आंतरिक संतुलन पर काम करने की जरूरत हो सकती है।',
  },
  practical: {
    name: 'व्यावहारिक / कर्म रेखा',
    strength: 'काम पूरा करने, जिम्मेदारी और व्यावहारिक प्रयास में मजबूती दिखती है।',
    weakness: 'निरंतरता, क्रियान्वयन और व्यावहारिक अनुशासन को मजबूत करना उपयोगी रहेगा।',
  },
  thought: {
    name: 'विचार और परिवार रेखा',
    strength: 'सीखने, परिवारिक जिम्मेदारी, अनुशासन और व्यवस्थित विकास को समर्थन।',
    weakness: 'पढ़ाई, परिवारिक पैटर्न और दीर्घकालिक योजना में सपोर्ट की जरूरत हो सकती है।',
  },
  will: {
    name: 'इच्छाशक्ति / दृढ़ता रेखा',
    strength: 'मजबूत इच्छाशक्ति, महत्वाकांक्षा, सहनशीलता और लक्ष्य पर टिके रहने की क्षमता।',
    weakness: 'आत्मविश्वास, दिशा और स्थिर प्रेरणा विकसित करने की जरूरत हो सकती है।',
  },
  relationship: {
    name: 'रिश्ते और सहयोग रेखा',
    strength: 'साझेदारी, रचनात्मक जुड़ाव, सहयोग और सामाजिक संवेदनशीलता।',
    weakness: 'विश्वास, साझेदारी और मदद मांगने में सचेत प्रयास की जरूरत हो सकती है।',
  },
  material: {
    name: 'भौतिक प्रबंधन रेखा',
    strength: 'संसाधन, रूटीन, सुविधा और व्यावहारिक जिम्मेदारियों को संभालने की क्षमता।',
    weakness: 'धन, सुविधा, जिम्मेदारी और दैनिक संरचना में संतुलन जरूरी है।',
  },
  spiritual: {
    name: 'आध्यात्मिक / अंतर्ज्ञान रेखा',
    strength: 'अंतर्ज्ञान, धैर्य, आंतरिक संतुलन और आध्यात्मिक परिपक्वता।',
    weakness: 'श्रद्धा, धैर्य और भावनात्मक स्थिरता को जमीन से जोड़ना उपयोगी रहेगा।',
  },
};

const patternHi: Record<string, { name: string; effect: string }> = {
  'royal-159': {
    name: 'दृढ़ संकल्प योग',
    effect: 'साहस, दिशा और लक्ष्य की ओर केंद्रित प्रयास को समर्थन देने वाला पैटर्न।',
  },
  'creative-357': {
    name: 'रचनात्मक हृदय योग',
    effect: 'अभिव्यक्ति, श्रद्धा और भावनात्मक समझ को समर्थन देने वाला पैटर्न।',
  },
  'wealth-discipline-456': {
    name: 'भौतिक अनुशासन योग',
    effect: 'रूटीन, सुविधा-योजना और व्यावहारिक जिम्मेदारी को मजबूत करने वाला पैटर्न।',
  },
  'wisdom-438': {
    name: 'ज्ञान अनुशासन योग',
    effect: 'अध्ययन, परिवारिक जिम्मेदारी और संरचित विकास को समर्थन।',
  },
  'support-276': {
    name: 'रिश्ता सहयोग योग',
    effect: 'सहयोग, रचनात्मक जुड़ाव और मददगार नेटवर्क को समर्थन।',
  },
  'spiritual-258': {
    name: 'अंतर्ज्ञान संतुलन योग',
    effect: 'धैर्य, अंतर्ज्ञान और आंतरिक परिपक्वता को समर्थन।',
  },
  'triangle-369': {
    name: 'रहस्यमय 3-6-9 त्रिकोण',
    effect: 'अभिव्यक्ति, विचार और प्रेरित कर्म से जुड़ा विशेष रचनात्मक-बौद्धिक पैटर्न।',
  },
  'triangle-147': {
    name: 'व्यावहारिक 1-4-7 त्रिकोण',
    effect: 'पहल, अनुशासन और शोध-प्रधान सोच को जोड़ने वाला पैटर्न।',
  },
  'triangle-258': {
    name: 'आंतरिक संतुलन 2-5-8 त्रिकोण',
    effect: 'संवेदनशीलता, केंद्र और धैर्य को जोड़ने वाला संतुलन पैटर्न।',
  },
};

export const loShuText = (isHindi: boolean, en: string, hi: string) => (isHindi ? hi : en);

export const loShuNumberTitle = (num: number, isHindi: boolean, fallback: string) =>
  isHindi ? numberHi[num]?.title || fallback : fallback;

export const loShuNumberMeaning = (num: number, isHindi: boolean, fallback: string) =>
  isHindi ? numberHi[num]?.meaning || fallback : fallback;

export const loShuNumberGuidance = (num: number, isHindi: boolean, fallback: string) =>
  isHindi ? numberHi[num]?.guidance || fallback : fallback;

export const loShuNumberDirection = (num: number, isHindi: boolean, fallback: string) =>
  isHindi ? numberHi[num]?.direction || fallback : fallback;

export const loShuArrowName = (arrow: { id: string; name: string }, isHindi: boolean) =>
  isHindi ? arrowHi[arrow.id]?.name || arrow.name : arrow.name;

export const loShuArrowStrength = (arrow: { id: string; strength: string }, isHindi: boolean) =>
  isHindi ? arrowHi[arrow.id]?.strength || arrow.strength : arrow.strength;

export const loShuArrowWeakness = (arrow: { id: string; weakness: string }, isHindi: boolean) =>
  isHindi ? arrowHi[arrow.id]?.weakness || arrow.weakness : arrow.weakness;

export const loShuPatternName = (item: { id: string; name: string }, isHindi: boolean) =>
  isHindi ? patternHi[item.id]?.name || item.name : item.name;

export const loShuPatternEffect = (item: { id: string; effect: string }, isHindi: boolean) =>
  isHindi ? patternHi[item.id]?.effect || item.effect : item.effect;

export const loShuDisclaimer = (isHindi: boolean, fallback: string) =>
  isHindi
    ? 'Lo Shu numerology आध्यात्मिक मार्गदर्शन और आत्म-चिंतन के लिए है। इसे मेडिकल, कानूनी, वित्तीय या मनोवैज्ञानिक सलाह का विकल्प न मानें।'
    : fallback;
